import { DEFAULT_LANGUAGE } from 'common/constants/locale.constants';
import { getBaseLanguage } from 'common/utils/locale.utils';
import { createI18n } from 'vue-i18n';

// Locale registry: every `<locale>.json` here is auto-registered via import.meta.glob (bundled at build time).
// concrete message type (not `unknown`) so vue-i18n picks the composition-mode createI18n overload
type MessageTree = { [key: string]: string | MessageTree };

const localeModules = import.meta.glob<MessageTree>('./*.json', { eager: true, import: 'default' });

export const messages: Record<string, MessageTree> = Object.fromEntries(
  Object.entries(localeModules).map(([filePath, module]) => [filePath.replace(/^\.\/(.+)\.json$/, '$1'), module]),
);

export const AVAILABLE_FRONTEND_LOCALES: readonly string[] = Object.keys(messages);

export const AVAILABLE_FRONTEND_BASE_LANGUAGES: readonly string[] = [
  ...new Set(AVAILABLE_FRONTEND_LOCALES.map((tag) => getBaseLanguage(tag))),
];

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LANGUAGE as string, // initLocale() resolves the real one before mount
  fallbackLocale: { default: [DEFAULT_LANGUAGE] },
  // fallback warnings are noise with sparse overlays; genuine missing keys still warn in dev
  missingWarn: true,
  fallbackWarn: false,
  escapeParameterHtml: false,
  warnHtmlMessage: false,
  messages,
});
